import { Badge } from "@/components/ui/badge";

// Canonical CO lifecycle: Draft → Submitted (customer) → Approved · Declined / Not approved are archived.
export const CO_STATUS_LABEL = { draft: "Draft", submitted: "Submitted", approved: "Approved", declined: "Declined", not_approved: "Not approved" };
export const CO_STATUS_TONE = {
  draft: "bg-slate-100 text-slate-600", submitted: "bg-amber-100 text-amber-700", approved: "bg-emerald-100 text-emerald-700",
  declined: "bg-red-100 text-red-700", not_approved: "bg-red-100 text-red-700",
};
export const CO_STATUS_ORDER = ["draft", "submitted", "approved", "declined", "not_approved"];

export function COStatusPill({ status, testId, className = "" }) {
  return (
    <Badge variant="outline" data-testid={testId}
      className={`inline-flex min-w-[5.5rem] justify-center whitespace-nowrap border-0 text-[10px] ${CO_STATUS_TONE[status] || "bg-slate-100 text-slate-600"} ${className}`}>
      {CO_STATUS_LABEL[status] || status || "—"}
    </Badge>
  );
}
